import HttpClientToken from '../../services/HttpClientToken';

import { AutoridadAmparoProps, defaultAutoridadAmparo } from '../../interfaces/catalogos/AutoridadAmparoInterface';

export const AutoridadAmparo = () => {

    return new Promise<AutoridadAmparoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/AutoridadAmparo/', token)
            .then( ({ data } : { data : AutoridadAmparoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerAutoridadAmparo = () => {

    return new Promise<AutoridadAmparoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/AutoridadAmparo/ObtenerAutoridadAmparo', token)
            .then( ({ data } : { data : AutoridadAmparoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarAutoridadAmparo = ( params: AutoridadAmparoProps ) => {

    return new Promise<AutoridadAmparoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/AutoridadAmparo/Actualizar', params, token)
            .then( ({ data } : { data : AutoridadAmparoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadAmparo } );
            });

        }

    });

}

export const AgregarAutoridadAmparo = ( params: AutoridadAmparoProps ) => {

    return new Promise<AutoridadAmparoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/AutoridadAmparo/Agregar', params, token)
            .then( ({ data } : { data : AutoridadAmparoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadAmparo } );
            });

        }

    });

}
